/**
 * 统一页面头部组件
 */
import React, { memo } from 'react';
import { Space, Tag } from 'antd';

/**
 * 页面头部组件
 * @param {string} title - 页面标题
 * @param {string} description - 页面描述
 * @param {React.ReactNode} actions - 操作按钮区域
 * @param {Array} tags - 标签数组 [{text, color}]
 * @param {string} className - 自定义类名
 */
const PageHeader = ({
  title,
  description,
  actions,
  tags = [],
  className = ''
}) => {
  return (
    <div className={`page-header ${className}`}>
      <div className="page-header-main">
        {title && <h1 className="page-title">{title}</h1>}
        {description && <p className="page-subtitle">{description}</p>}
        {tags.length > 0 && (
          <Space size="small" style={{ marginTop: 12 }}>
            {tags.map((tag, index) => (
              <Tag key={index} color={tag.color || 'default'}>
                {tag.text}
              </Tag>
            ))}
          </Space>
        )}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
  );
};

export default memo(PageHeader);